/** Map API linked_individuals item to UI row shape */
export const mapLinkedUserFromApi = (user) => ({
    ulid: user.user_ulid || user.ulid || user.id,
    name: user.name || '',
    email: user.primary_email || user.email || '',
    phone: user.mobile_number || user.phone || '',
    emailNotification: !!(user.email_enabled ?? user.email_notification_enabled),
    whatsappNotification: !!(user.whatsapp_enabled ?? user.whatsapp_notification_enabled),
});

/** Map UI rows to PATCH linked_individuals payload */
export const mapLinkedUserToApi = (user) => ({
    user_ulid: user.ulid,
    name: user.name,
    primary_email: user.email,
    mobile_number: user.phone,
    email_enabled: !!user.emailNotification,
    whatsapp_enabled: !!user.whatsappNotification,
});

/** Open Knots main switch — GET/PATCH /iam/{orgId}/open-knots */
export const parseOpenKnotsEnabled = (payload) =>
    !!(
        payload?.enabled ??
        payload?.open_knots_enabled ??
        payload?.organization?.open_knots_enabled
    );

/** GET/POST linked WhatsApp numbers — API item → UI row */
export const mapLinkedWhatsappNumberFromApi = (item) => ({
    id: item?.ulid || item?.id,
    contactName: item?.contact_name || item?.contactName || '',
    whatsappNumber: item?.whatsapp_number || item?.whatsappNumber || '',
});

/** GET payload.numbers → UI rows */
export const mapLinkedWhatsappNumbersFromApi = (payload) =>
    (payload?.numbers || []).map(mapLinkedWhatsappNumberFromApi).filter((row) => row.id);

/** POST/PUT may return a single mapping or the full GET list shape. */
export const mapCreatedLinkedWhatsappNumberFromApi = (payload) => {
    const fromItem = mapLinkedWhatsappNumberFromApi(payload);
    if (fromItem.id) {
        return fromItem;
    }
    const list = mapLinkedWhatsappNumbersFromApi(payload);
    return list[list.length - 1] || null;
};

export const mapOrganizationSummary = (payload, organizationUlid) => {
    const company = payload?.companyDetails || payload?.organization || {};
    const individuals = payload?.individualDetails || [];
    const individualRole = (individuals.find((i) => i?.platform_role)?.platform_role || '').toLowerCase();
    const profileType = (
        payload?.profile_type ||
        company?.organization_type ||
        payload?.organization_type ||
        individualRole ||
        company?.customer_type ||
        payload?.customer_type ||
        ''
    ).toLowerCase();

    return {
        organization_ulid: payload?.ulid || company?.ulid || organizationUlid,
        organization_name: company?.name || payload?.name || '',
        profile_type: profileType,
        customer_code: company?.customer_code || payload?.customer_code,
        trade_knots_enabled: !!(company?.trade_knots_enabled ?? payload?.trade_knots_enabled),
        deal_knots_enabled: !!(company?.deal_knots_enabled ?? payload?.deal_knots_enabled),
        open_knots_enabled: !!(company?.open_knots_enabled ?? payload?.open_knots_enabled),
    };
};
